module.exports = __webpack_public_path__ + "static/media/cae.248acc10.svg";